import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBag, XIcon } from 'lucide-react';
const names = ['María L.', 'Juan C.', 'Luciana G.', 'Martín R.', 'Carolina S.', 'Diego F.', 'Valeria M.', 'Sebastián P.', 'Florencia T.', 'Nicolás B.', 'Andrea V.', 'Pablo H.', 'Romina D.', 'Facundo A.', 'Gabriela N.', 'Alejandro K.', 'Daniela O.', 'Fernando E.', 'Soledad I.', 'Gustavo W.', 'Laura Z.', 'Hernán J.', 'Natalia Q.', 'Rodrigo U.', 'Cecilia X.'];
const cities = ['Ciudad de México', 'Bogotá', 'Lima', 'Santiago', 'Buenos Aires', 'Guadalajara', 'Medellín', 'Monterrey', 'Quito', 'Guayaquil', 'Montevideo', 'Asunción', 'San José', 'Ciudad de Panamá', 'Santo Domingo', 'Córdoba', 'Rosario', 'Cali', 'Arequipa', 'Puebla', 'Valparaíso', 'Barranquilla', 'La Paz'];
function getRandomItem<T>(arr: T[]): T {
  return arr[Math.floor(Math.random() * arr.length)];
}
export function SocialProofPopup() {
  const [visible, setVisible] = useState(false);
  const [data, setData] = useState({
    name: '',
    city: '',
    minutes: 0
  });
  useEffect(() => {
    let hideTimeout: ReturnType<typeof setTimeout>;
    function showNotification() {
      setData({
        name: getRandomItem(names),
        city: getRandomItem(cities),
        minutes: Math.floor(Math.random() * 15) + 2
      });
      setVisible(true);
      clearTimeout(hideTimeout);
      hideTimeout = setTimeout(() => setVisible(false), 4000);
    }
    const initialTimeout = setTimeout(showNotification, 15000);
    const interval = setInterval(showNotification, 35000 + Math.random() * 15000);
    return () => {
      clearTimeout(initialTimeout);
      clearTimeout(hideTimeout);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-383" data-mp="104fgomoz2l9f">
      {visible && <motion.div initial={{
      opacity: 0,
      x: -24
    }} animate={{
      opacity: 1,
      x: 0
    }} exit={{
      opacity: 0,
      x: -24
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed bottom-24 left-4 z-[60] max-w-xs md:bottom-6" role="status" data-id="element-384" data-mp="1f0enlu0cifcz">
          <div className="flex items-start gap-3 rounded-2xl border border-white/10 bg-slate-900/95 p-3.5 shadow-2xl shadow-black/50 backdrop-blur-md" data-id="element-385" data-mp="1m31zdy7b1tmm">
            <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-emerald-500/15" data-id="element-386" data-mp="1r1dasdd90c6y">
              <ShoppingBag size={18} className="text-emerald-400" aria-hidden="true" data-id="element-387" data-mp="1vvhemnr7w43t" />
            </div>
            <div className="min-w-0" data-id="element-388" data-mp="20uu29apwxf7g">
              <p className="text-sm font-semibold text-white" data-id="element-389" data-mp="24tbda5cgf9u5">
                {data.name} de {data.city}
              </p>
              <p className="text-xs text-slate-300" data-id="element-390" data-mp="29uh39veqcizz">
                compró <span className="font-semibold text-sky-400" data-id="element-391" data-mp="2essg8f0bn9mf">MEGAPACK Funcional 365</span>
              </p>
              <p className="mt-0.5 text-xs text-slate-500" data-id="element-392" data-mp="ffof2hg6eui2">hace {data.minutes} minutos</p>
            </div>
            <button onClick={() => setVisible(false)} className="ml-auto mt-0.5 shrink-0 text-slate-500 transition-colors duration-150 hover:text-white" aria-label="Cerrar notificación" data-id="element-393" data-mp="kdg515x9g6jm">
              <XIcon size={14} aria-hidden="true" data-id="element-394" data-mp="81x7a13affue" />
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}